import axios from 'axios';
import { defaultAxiosConfig, getAcessToken } from './commom';

const apiService = axios.create({
  baseURL: process.env.BFF_URL,
  ...defaultAxiosConfig,
});

apiService.interceptors.request.use(
  (request) => getAcessToken(request),
  (err) => Promise.reject(err)
);

apiService.interceptors.response.use(
  (response) => response.data,
  (err) => {
    if (axios.isCancel(err)) return Promise.reject(err);

    if (err.response === undefined) {
      return Promise.reject(new Error('Não foi possível conectar ao servidor.'));
    }

    if (err.response.status === 401) {
      window.location.assign(process.env.FRETEBRAS_LOGOUT_URL);
      return Promise.resolve();
    }

    return Promise.reject(err);
  }
);

export default apiService;
